import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PcpItem } from '@core/interfaces/entities';
import { PlatformLocation } from '@angular/common';


@Component({
  selector: 'app-pcp-selection-modal',
  templateUrl: './pcp-selection-modal.component.html',
  styleUrls: ['./pcp-selection-modal.component.scss'],
})
export class PcpSelectionModalComponent {

  @Output() selectionMade = new EventEmitter();
  @Output() pageChanged = new EventEmitter();
  @Input() pcpProviders: { total: number, items: Array<PcpItem>, };
  @Input()
  page = 1;

  pageSize = 10;

  public readonly translationPrefix = 'common.modals.pcpModal';

  constructor(public activeModal: NgbActiveModal, private location: PlatformLocation) {
    location.onPopState(() => activeModal.close());
  }

  emitSelectionMade(pcpInfo) {
    this.selectionMade.emit(pcpInfo);
    this.activeModal.dismiss();
  }

  emitChangePage(page) {
    this.page = page;
    this.pageChanged.emit({ page: page > 0 ? page - 1 : 0, pageSize: this.pageSize });
  }

}
